<template>
  <VsModal @close="$emit('close')">
    <h1 class="title">
      {{ "datalink.warning1" | t }}
    </h1>
    <div class="description">
      <p>{{ "datalink.warning2" | t }}</p>
    </div>
    <div class="buttons">
      <div class="columns">
        <div class="column is-half">
          <button class="button is-fullwidth" @click="$emit('close')">
            {{ "datalink.cancel" | t }}
          </button>
        </div>
        <div class="column is-half">
          <button class="button is-danger is-fullwidth" @click="deleteRecord()">
            {{ "datalink.yesDelete" | t }}
          </button>
        </div>
      </div>
    </div>
  </VsModal>
</template>

<script>
export default {
  methods: {
    deleteRecord() {
      this.$parent.$parent.deleteRecord();
      this.$parent.close();
    },
  },
};
</script>

<style scoped lang="scss">
.title {
  color: $gray-800;
  font-size: 31px;
}

.buttons {
  margin-top: 30px;

  .columns {
    width: 100%;
  }
}
</style>
